export const isArrayString = (value) => {
	return value[0] === "[" && value[value.length - 1] === "]";
}
